var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgAgentsIcon = function SvgAgentsIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__a",
    x1: "33.407%",
    x2: "88.624%",
    y1: "5.42%",
    y2: "96.117%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#53F7DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#31BA9B"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#7FC6B7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.01 2.764c0 1.523 1.24 2.763 2.763 2.763 1.524 0 2.764-1.24 2.764-2.763C7.537 1.24 6.297 0 4.773 0 3.25 0 2.01 1.24 2.01 2.764zM0 10.232c0 .177.142.32.318.32h8.91c.176 0 .319-.143.319-.32 0-2.294-1.856-4.202-4.137-4.202H4.137C1.856 6.03 0 7.938 0 10.232z",
    transform: "translate(0 1.005)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#7FC6B7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.01 2.764c0 1.523 1.24 2.763 2.763 2.763 1.524 0 2.764-1.24 2.764-2.763C7.537 1.24 6.297 0 4.773 0 3.25 0 2.01 1.24 2.01 2.764zM0 10.232c0 .177.142.32.318.32h8.91c.176 0 .319-.143.319-.32 0-2.294-1.856-4.202-4.137-4.202H4.137C1.856 6.03 0 7.938 0 10.232z",
    transform: "translate(9.044 1.005)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__a)",
    d: "M6.673 7.851c2.814 0 5.103 2.342 5.103 5.155 0 .217-.175.393-.392.393H.393c-.217 0-.393-.176-.393-.393 0-2.813 2.29-5.155 5.103-5.155zM5.888 0c1.948 0 3.533 1.585 3.533 3.533S7.836 7.066 5.888 7.066 2.355 5.48 2.355 3.533 3.94 0 5.888 0z",
    transform: "translate(3.015)"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAgentsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/agents_icon.72c4710a.svg";
export { ForwardRef as ReactComponent };